import { render, staticRenderFns } from "./PlaceholderIcon.vue?vue&type=template&id=1c106b62&"
import script from "./PlaceholderIcon.vue?vue&type=script&lang=js&"
export * from "./PlaceholderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports